export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_COMPANY_USERS = 'SET_COMPANY_USERS';
export const SET_USER = 'SET_USER';
export const DELETE_COMPANY_USER = 'DELETE_COMPANY_USER';
export const SET_USER_ADDED = 'SET_USER_ADDED';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_WAREHOUSES_LIST = 'SET_WAREHOUSES_LIST';
export const REMOVE_WAREHOUSE = 'REMOVE_WAREHOUSE';
export const HANDLE_CHANGED_PASSWORD = 'HANDLE_CHANGED_PASSWORD';
export const HANDLE_ACCOUNT_UPDATED = 'HANDLE_ACCOUNT_UPDATED';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_WAREHOUSE_ADMINS = 'SET_WAREHOUSE_ADMINS';
export const SET_WAREHOUSE = 'SET_WAREHOUSE';
export const SET_INVITED_ADMIN = 'SET_INVITED_ADMIN';
export const SET_INVITED_USER = 'SET_INVITED_USER';
export const SET_BOOKS = 'SET_BOOKS';
export const HIDE_REQUESTED_NOTIFICATION = 'HIDE_REQUESTED_NOTIFICATION';
export const ADD_BOOK = 'ADD_BOOK';
export const DELETE_BOOK = 'DELETE_BOOK';
export const UPDATE_BOOK = 'UPDATE_BOOK';
export const ADD_USER = 'ADD_USER';


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js